import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import { tipoImpressaoCupom } from '../../util/constantsUtil';

class PrintContent extends Component {
  render() {
    const { referencias, referenciasCheckeds } = this.props;
    const referenciasMarcadas = referenciasCheckeds
      .filter(ref => ref.checked)
      .map(ref => ref.key);

    const elementosProntos = referenciasMarcadas.every(refId => {
      const referencia = referencias.get(refId);
      return referencia && referencia.referencia && referencia.referencia.current;
    });

    if (!elementosProntos) {
      return <div></div>;
    }

    return (
      <div>
        {referenciasMarcadas.map((refId) => {
          const referencia = referencias.get(refId);
          return (
            <div key={refId}
                 dangerouslySetInnerHTML={{ __html: referencia.referencia.current.outerHTML }}/>
          );
        })}
      </div>
    );
  }
}

export default class ModalImpressaoCupomBagagem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referenciaSelecionada: [],
      isPrinting: false,
    };
  }

  componentDidMount() {
    if (this.props.referencias) {
      const todasReferencias = [...this.props.referencias.keys()];
      this.setState({ referenciaSelecionada: todasReferencias });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.referencias !== this.props.referencias && this.props.referencias) {
      const todasReferencias = [...this.props.referencias.keys()];
      this.setState({ referenciaSelecionada: todasReferencias });
    }
  }

  adicionarChebox(ref) {
    let referenciaSelecionada = Object.assign([], this.state.referenciaSelecionada);
    if (referenciaSelecionada.length === 0 || referenciaSelecionada.filter(it => it === ref).length === 0) {
      referenciaSelecionada.push(ref);
      this.setState({ referenciaSelecionada });
    } else {
      referenciaSelecionada = referenciaSelecionada.filter(it => !(it === ref));
      this.setState({ referenciaSelecionada });
    }
    this.props.marcarReferencia(ref);
  }

  handlePrint() {
    this.setState({ isPrinting: true }, () => {
      setTimeout(() => {
        this.forceUpdate();
        setTimeout(() => {
          window.print();
          this.setState({ isPrinting: false });
        }, 100);
      }, 1000);
    });
  }

  exibirBotaoImprimir() {
    if (this.props.tipo === tipoImpressaoCupom.normal) {
      return (
        <button
          disabled={!this.props.pagina}
          onClick={() => this.props.pagina.print()}
          className="vx-modal-btn-confirmar">
          <span className="material-icons" style={{fontSize: 15}}>print</span>
          Imprimir
        </button>
      );
    }

    if (this.props.tipo === tipoImpressaoCupom.termica) {
      const { referenciaSelecionada } = this.state;
      const { referencias } = this.props;
      const semSelecao = referenciaSelecionada.length <= 0;

      return (
        <React.Fragment>
          <ReactToPrint
            trigger={() => (
              <button className="vx-modal-btn-confirmar" disabled={semSelecao}
                      onClick={this.handlePrint.bind(this)}>
                <span className="material-icons" style={{fontSize: 15}}>print</span>
                Imprimir
              </button>
            )}
            content={() => this.printComponent}
            documentTitle={'cupom-bagagem'}
          />
          <div style={{ display: 'none' }}>
            <PrintContent
              ref={(el) => (this.printComponent = el)}
              referencias={referencias}
              referenciasCheckeds={this.props.referenciasCheckeds}/>
          </div>
        </React.Fragment>
      );
    }

    return null;
  }

  limparTudo() {
    this.setState({ referenciaSelecionada: [] });
    this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal);
    this.props.limparMarcacaoReferenciasCheckeds();
    this.props.habilitarDesabilitarReciboCupomBagagem(false);
  }

  render() {
    const { tipo } = this.props;
    const isNormal = tipo === tipoImpressaoCupom.normal;
    const isTermica = tipo === tipoImpressaoCupom.termica;

    return (
      <div className="modal fade show" id='modalImpressaoCupomBagagem' role='dialog'
           aria-labelledby='modalImpressaoCupomBagagem' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">print</span>
                Imprimir Cupom de Bagagem
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar"
                      onClick={() => this.limparTudo()}>
                <span className="material-icons">close</span>
              </button>
            </div>

            <div className="vx-modal-body" style={{background: '#fff'}}>
              <div className="vx-modal-section">
                <div className="vx-modal-section-title">
                  <span className="material-icons">tune</span>
                  Tipo de impressão
                </div>

                <div className={`vx-print-opt${isNormal ? ' vx-print-opt--active' : ''}`}
                     onClick={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal)}>
                  <input type="radio"
                         onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal)}
                         checked={isNormal}/>
                  <span className="vx-print-opt-label">Normal</span>
                </div>

                <div className={`vx-print-opt${isTermica ? ' vx-print-opt--active' : ''}`}
                     onClick={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.termica)}>
                  <input type="radio"
                         onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.termica)}
                         checked={isTermica}/>
                  <span className="vx-print-opt-label">Térmica</span>
                </div>

                {isTermica && (
                  <div className="vx-print-check-list">
                    {[...this.props.referencias.keys()].map((ref) => (
                      <div className="vx-print-check-item" key={ref}
                           onClick={() => this.adicionarChebox(ref)}>
                        <input
                          type="checkbox"
                          onChange={() => this.adicionarChebox(ref)}
                          checked={this.props.referenciasCheckeds.filter(it => it.key === ref)[0]?.checked || false}
                        />
                        <span>{this.props.referencias.get(ref).nome}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="vx-modal-footer">
              <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                      onClick={() => this.limparTudo()}>
                Cancelar
              </button>
              {this.exibirBotaoImprimir()}
            </div>

          </div>
        </div>
      </div>
    );
  }
}
